import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import AppBar from 'pencil/AppBar';
import Toolbar from 'pencil/Toolbar';
import ProfileSelector from 'domain/fuse/auth/profiles/container';
import { makeStyles, useTheme } from 'pencil/styles';
import Container from 'pencil/Container';
import Box from 'pencil/Box';
// import AccountManagementNotifications from 'domain/operations/accountManagement/container';
import Typography from 'pencil/Typography';
import CompanyDialog from 'domain/fuse/preferences/code/CompanyDialog';
import LanguageSwitcher from './LanguageSwitcher';
import { HEADER_HEIGHT } from '../constants';
import { useWidth } from '../../fuse/layout/utils';
import NotificationContainer from './NotificationContainer';

const DRAWER_WIDTH = 395;
const DRAWER_CLOSE_WIDTH = 100;

const useStyles = makeStyles(
  (theme) => ({
    container: {
      backgroundColor: theme.branding.background.primary,
    },
    headerWidth: {
      width: `calc(100% - ${DRAWER_CLOSE_WIDTH}px)`,
    },
    appBar: {
      background: 'white',
      boxShadow: ['none'],
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: DRAWER_WIDTH,
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toolbar: {
      borderBottom: `1px solid ${theme.colors.lightGrey}`,
      height: `${HEADER_HEIGHT}px`,
      ...theme.mixins.toolbar,
    },
    code: {
      padding: theme.spacing(1),
      border: `1px solid ${theme.colors.lightGrey}`,
      marginTop: theme.spacing(1),
      color: theme.colors.black,
      textAlign: 'center',
      display: 'block',
    },
    grow: {
      flexGrow: 1,
    },
    notificationSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '2px',
    },
    headerTitle: {
      color: theme.palette.secondary.main,
    },
  }),
  { name: 'MlcGoHeader' },
);

const Header = ({
  handleDrawerOpen,
  open: openStatus,
  logout,
  userData,
  isAccountAdmin,
  accountToken,
  onCompanyCodeOpen,
  currentPageTitle,
  activeNotifications,
  newNotifications,
  clearNotifications,
  prevNewNotificationsLength,
  ...rest
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const width = useWidth();
  const [auth, setAuth] = useState(true);
  const [anchorEl, setAnchorEl] = useState();
  const [open, setOpen] = useState(false);

  const name = userData && userData.given_name ? userData.given_name : userData.name;
  const openMenu = Boolean(anchorEl);

  useEffect(() => {
    if (typeof onCompanyCodeOpen === 'function') {
      onCompanyCodeOpen();
    }
  }, [open]);

  useEffect(() => {
    if (currentPageTitle) {
      const notificationCounter = activeNotifications.length
        ? `(${activeNotifications.length}) `
        : '';
      document.title = `${notificationCounter} ${currentPageTitle} | ${SITE_TITLE}`;
    }
  }, [currentPageTitle, activeNotifications]);

  function handleClickOpen() {
    setOpen(true);
  }

  function handlePopupClose() {
    setOpen(false);
  }

  function handleChange(event) {
    setAuth(event.target.checked);
  }

  function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <Box displayPrint="none">
      <AppBar
        position="fixed"
        color="default"
        className={classNames(
          classes.appBar,
          {
            [classes.appBarShift]: openStatus,
          },
          classes.headerWidth,
        )}
      >
        {open && (
          <CompanyDialog
            open={open}
            handlePopupClose={handlePopupClose}
            accountToken={accountToken}
          />
        )}
        <Container maxWidth={theme.layout.width} className={classes.container}>
          <Toolbar classes={{ root: classes.toolbar }} disableGutters={!open}>
            <Typography variant="h5" className={classes.headerTitle} gutterBottom align="center">
              <Box fontWeight="bold">{currentPageTitle}</Box>
            </Typography>

            <div className={classes.grow} />
            <div className={classes.notificationSection}>
              <NotificationContainer
                newNotifications={newNotifications}
                clearNotifications={clearNotifications}
                prevNewNotificationsLength={prevNewNotificationsLength}
              />
              <LanguageSwitcher />
              {/* <AccountManagementNotifications /> */}
              <ProfileSelector
                user={userData}
                isAccountAdmin={isAccountAdmin}
                onCompanyCodeClick={handleClickOpen}
                onLogout={logout}
              />
            </div>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};

Header.propTypes = {};

export default Header;
